export const BUSINESS_SIGN_IN = (lang: string): string =>
  `${URLS.business}/${lang}/public/sign-in/`;
export const BUSINESS_SIGN_UP = (lang: string): string =>
  `${URLS.business}/${lang}/public/sign-up/`;
